import DeviceStatus from '../../../constants/deviceStatus';
export const getDeviceStatusDescription = (deviceStatus) => {
    switch (deviceStatus) {
        case DeviceStatus.OK:
            return 'Online';
        case DeviceStatus.NEUTRAL:
            return 'Unknown';
        case DeviceStatus.WARN:
            return 'Unstable';
        case DeviceStatus.ERROR:
            return 'Offline';
        default:
            return 'Unknown';
    }
};
